import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStatePositionsHours, IPositionsHoursPayload } from "../types";
import { GetDeletedPositionsHours, GetPositionsHours } from "./thunk";

const initialState: IInitialStatePositionsHours = {
    positionsHours: [],
    isLoadingPositionsHours: true,
    isViewPositionsHoursRestore: false,
    positionsHoursRestore: [],
    selectedPositionsHoursIDs: [],
};

const positionsHoursSlice = createSlice({
    name: "positionsHours",
    initialState,
    reducers: {
        setPositionsHours: (state, action: PayloadAction<IPositionsHoursPayload[]>) => {
            state.positionsHours = action.payload;
        },
        deletedRestorePositionsHours: (state, action) => {
            state.positionsHoursRestore = state.positionsHoursRestore.filter(item => item.id !== action.payload);
        },
        deletePositionsHours: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.positionsHours = state.positionsHours.filter(item => item.id !== id);
        },
        setSelectedPositionsHoursIDs: (state, action) => {
            state.selectedPositionsHoursIDs = action.payload;
        },
        setPositionsHoursRestore: (state, action) => {
            state.positionsHoursRestore = action.payload;
        },
        setIsViewPositionsHoursRestore: state => {
            state.isViewPositionsHoursRestore = !state.isViewPositionsHoursRestore;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetPositionsHours.pending, state => {
                state.isLoadingPositionsHours = true;
            })
            .addCase(GetPositionsHours.fulfilled, state => {
                state.isLoadingPositionsHours = false;
            })
            .addCase(GetPositionsHours.rejected, state => {
                state.isLoadingPositionsHours = false;
            })
            .addCase(GetDeletedPositionsHours.pending, state => {
                state.isLoadingPositionsHours = true;
            })
            .addCase(GetDeletedPositionsHours.fulfilled, state => {
                state.isLoadingPositionsHours = false;
            })
            .addCase(GetDeletedPositionsHours.rejected, state => {
                state.isLoadingPositionsHours = false;
            });
    },
});

export const {
    setPositionsHours,
    deletedRestorePositionsHours,
    setSelectedPositionsHoursIDs,
    deletePositionsHours,
    setPositionsHoursRestore,
    setIsViewPositionsHoursRestore,
} = positionsHoursSlice.actions;

export default positionsHoursSlice;
